/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Modal } from '@mairistem/composants';

import ActeListeContainer from '@/components/Acte/Liste/ActeListeContainer';

interface ActeModalProps {
  open: boolean;
  title?: string;
  annee?: number;
  mois?: number;
  typeActe?:
    | 'naissance'
    | 'reconnaissance'
    | 'mariage'
    | 'deces'
    | 'decision'
    | 'pacs'
    | 'mention';
  onClose: () => void;
}

const ActeModal = (props: ActeModalProps) => {
  const { open, title, annee, mois, typeActe, onClose } = props;

  return (
    <Modal open={open} onClose={onClose} size="large" closeIcon>
      <Modal.Header content={title} />
      {/* @ts-expect-error Type error */}
      <Modal.Content style={{ height: '700px' }}>
        <div style={{ height: '560px' }}>
          <ActeListeContainer
            annee={annee}
            mois={mois}
            typeActe={typeActe}
            stats
            modal
          />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          size="small"
          icon="close"
          content="Fermer"
          onClick={onClose}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ActeModal;
